import { styled, styledForMobile } from "@l2r-front/l2r-ui"

export const Wrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
})

export const LegendsWrapper = styledForMobile("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    paddingTop: theme.spacing(6),
}))

export const LegendWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(3),
}))

export const StrokeContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexShrink: 0,
    width: 20,
}))

export const Stroke = styled("div")(({ theme }) => ({
    flex: 1,
    height: 4,
    backgroundColor: theme.palette["objects/object-black"].main,
    borderRadius: 2,
}))